import React from 'react';
import {Slide, Snackbar} from "@mui/material";
import {Alert} from '@mui/material'
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";

const ModalAlert = ({data, onClose, autoHide = true}) => {
    const closeOnClick = !autoHide && data.type === "error"

    return (
        <Snackbar
            open={data.open} onClose={onClose}
            TransitionComponent={Slide} autoHideDuration={closeOnClick ? null : 10000}
            anchorOrigin={{vertical: 'top', horizontal: 'center'}}
        >
            <Alert sx={{alignItems: "center"}}
                   severity={data.type}>
                {data.message}
                {closeOnClick && <IconButton
                    aria-label="close"
                    color="inherit"
                    size="small"
                    onClick={onClose}
                >
                    <CloseIcon fontSize="inherit"/>
                </IconButton>}
            </Alert>
        </Snackbar>
    )
}
export default ModalAlert
